import { render, staticRenderFns } from "./dashboards-table.vue?vue&type=template&id=2ce5b3a8&"
import script from "./dashboards-table.vue?vue&type=script&lang=js&"
export * from "./dashboards-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports